import React, { useState } from 'react';
import ProfileSettingsModal from '../ProfileSettingsModal';
import GetStartedModal from './GetStartedModal';
import AvatarCreatorModal from '../AvatarCreatorModal';

const OnboardingFlow = ({ onComplete, initialProfileData }) => {
  console.log('OnboardingFlow rendered with:', { initialProfileData });
  const [currentStep, setCurrentStep] = useState('get-started'); // 'get-started', 'avatar', 'profile'
  const [profileData, setProfileData] = useState(initialProfileData || {});

  const handleGetStartedComplete = () => {
    setCurrentStep('avatar');
  };

  const handleAvatarComplete = (avatarData) => {
    if (avatarData && avatarData.url) {
      setProfileData(prev => ({
        ...prev,
        avatar_url: avatarData.url
      }));
    }
    setCurrentStep('profile');
  };

  const handleProfileComplete = async (e) => {
    e.preventDefault();
    onComplete(profileData);
  };

  const handleProfileChange = (field, value) => {
    setProfileData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Render the appropriate step
  switch (currentStep) {
    case 'get-started':
      return (
        <GetStartedModal
          show={true}
          onComplete={handleGetStartedComplete}
        />
      );
    
    case 'avatar':
      return (
        <AvatarCreationStep
          show={true}
          onComplete={handleAvatarComplete}
          onBack={() => setCurrentStep('get-started')}
        />
      );
    
    case 'profile':
      return (
        <ProfileSettingsModal
          show={true}
          onClose={() => {}} // Disable closing during onboarding
          onSubmit={handleProfileComplete}
          profileData={profileData}
          onChange={handleProfileChange}
          isOnboarding={true}
        />
      );
    
    default:
      return null;
  }
};

// Avatar Creation Step Component
const AvatarCreationStep = ({ show, onComplete, onBack }) => {
  const [showAvatarCreator, setShowAvatarCreator] = useState(true);

  const handleAvatarSave = (avatarData) => {
    onComplete(avatarData);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg p-8 max-w-md w-full shadow-lg text-center">
        <h2 className="text-2xl font-bold text-[#001427] mb-4">
          Create Your Avatar
        </h2>
        <p className="text-gray-600 mb-6">
          Let's create your unique avatar to represent you in the tennis community!
        </p>
        
        <button
          onClick={() => setShowAvatarCreator(true)}
          className="w-full px-6 py-3 bg-[#0D9488] text-white rounded-lg hover:bg-[#0A7C72] transition-colors flex items-center justify-center space-x-2 mb-4"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          <span>Create Avatar</span>
        </button>

        <button
          onClick={onBack}
          className="text-gray-500 hover:text-gray-700 text-sm"
        >
          ← Back
        </button>
      </div>

      {/* Avatar Creator Modal */}
      {showAvatarCreator && (
        <AvatarCreatorModal
          show={showAvatarCreator}
          onClose={() => setShowAvatarCreator(false)}
          onSave={handleAvatarSave}
        />
      )}
    </div>
  );
};

export default OnboardingFlow; 